var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallengeHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:hourglass-fill",
    clipPath: "url(#clip0_3197_4247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 4.25964H6C4.89543 4.25964 4 3.36421 4 2.25964C4 1.15507 4.89543 0.259644 6 0.259644H34C35.1046 0.259644 36 1.15507 36 2.25964C36 3.36421 35.1046 4.25964 34 4.25964H32V8.25964C32 11.4896 30.368 14.0896 28.312 16.2136C26.906 17.6656 25.196 19.0036 23.462 20.2596C25.196 21.5156 26.906 22.8536 28.312 24.3056C30.368 26.4296 32 29.0296 32 32.2596V36.2596H34C35.1046 36.2596 36 37.1551 36 38.2596C36 39.3642 35.1046 40.2596 34 40.2596H6C4.89543 40.2596 4 39.3642 4 38.2596C4 37.1551 4.89543 36.2596 6 36.2596H8V32.2596C8 29.0296 9.632 26.4296 11.688 24.3056C13.094 22.8536 14.804 21.5156 16.538 20.2596C14.804 19.0036 13.094 17.6656 11.688 16.2136C9.632 14.0896 8 11.4896 8 8.25964V4.25964ZM12 4.25964V8.25964C12 9.62964 12.52 10.9296 13.542 12.2596H26.458C27.478 10.9296 28 9.62964 28 8.25964V4.25964H12ZM20 22.7036C17.91 24.1796 16.016 25.5856 14.562 27.0876C14.2001 27.4587 13.8595 27.85 13.542 28.2596H26.458C26.1404 27.85 25.7999 27.4587 25.438 27.0876C23.984 25.5856 22.09 24.1796 20 22.7036Z",
    fill: "#FBD38D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3197_4247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.110229)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeHourglass);
export default __webpack_public_path__ + "static/media/ChallengeHourglass.4ce2f2f57d60cc29c7bcb9a34b4749cd.svg";
export { ForwardRef as ReactComponent };